import { render, staticRenderFns } from "./Dashboards.vue?vue&type=template&id=ff1c9f5e"
import script from "./Dashboards.vue?vue&type=script&lang=js"
export * from "./Dashboards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports